<style lang="scss" scoped>
.faq {
    .header {
        position: relative;
        cursor: pointer;

        &:after {
            content: "";
            background-image: url("/svg/chevron-down.svg");
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            width: 24px;
            height: 24px;
            position: absolute;
            right: 0;
            top: 24px;
            transition: transform 0.2s;
        }

        &.open {
            &:after {
                transform: rotate(-180deg);
            }
        }
    }

    .content {
        p {
            margin-top: 4px;
            margin-bottom: 24px;
            line-height: 1.25rem;
        }
    }

    ::v-deep {
        .v-collapse-group {
            > div {
                &:last-child {
                    border: 0;
                }
            }
        }
    }
}
</style>

<template>
    <div class="faq">
        <v-collapse-group>
            <v-collapse-wrapper v-for="(item, index) in faqData" :key="index" class="last:border-none border-b border-gray-100">
                <p class="header text-14 text-dark no-select py-24 pr-40 font-medium leading-tight" @click="headerClick" v-collapse-toggle v-html="item.title.rendered"></p>
                <div class="content" v-collapse-content>
                    <p v-html="item.acf.answer" class="text-14 text-blue opacity-70 mb-0"></p>
                </div>
            </v-collapse-wrapper>
        </v-collapse-group>
    </div>
</template>

<script>
export default {
    name: "Ui.Faq",

    props: {
        faqData: {
            type: Array,
            required: true
        }
    },

    methods: {
        headerClick(e) {
            e.target.classList.toggle('open');
        }
    }
}
</script>